<!-- <iframe *ngIf="inputData.base64Data" [src]="documentSrc"
width="100%" height="800" frameborder="0"
    webkitallowfullscreen mozallowfullscreen allowfullscreen>
</iframe> -->

<div class="modal-body" style="background: #ffffff;">
  <!-- Desktop PDF Viewer -->
  <iframe
    *ngIf="!isMobile && inputData.base64Data"
    [src]="documentSrc"
    style="width: 100%; height: 90vh; border: none;"
    allowfullscreen
    webkitallowfullscreen
    mozallowfullscreen>
  </iframe>

  <!-- Mobile fallback button -->
  <button
    *ngIf="isMobile && inputData.base64Data"
    (click)="openInNewTab()"
    class="btn btn-primary m-3">
    Open Document
  </button>
</div>



